import { IToast } from '../interfaces/globals';
import { TRANSLATIONS_TOAST } from '../translations/commons';

export const DEFAULT_TOAST_DATA: IToast = {
  message: '',
  variant: 'success'
};

export const LOGIN_ERROR_TOAST: IToast = {
  message: TRANSLATIONS_TOAST.loginError.message,
  variant: 'danger'
};

export const GENERIC_ERROR_TOAST: IToast = {
  message: TRANSLATIONS_TOAST.genericError.message,
  variant: 'danger'
};
